import {React, useEffect, useState} from "react";
import "../../../styles/desktop/legendaCaixaDagua.css";
import caixa from "../../../assets/img/CaixaDagua.png";

const LegendaCaixadagua = ({ luzesStatus }) => {

    const [caixaDagua01, setcaixaDagua01] = useState ({
        alto: false,
        altoFluxostato: false,
        normal: true,
        baixo: false
    });
    
    const [caixaDagua02, setcaixaDagua02] = useState ({
        alto: false,
        altoFluxostato: false,
        normal: true,
        baixo: false
    });

    const updatecaixaDagua01 = (state) => {
        if (state[9]?.dados?.[2] === "ON") {
            setcaixaDagua01({ alto: false, altoFluxostato: false, normal: false, baixo: true });
        } else if (state[8]?.dados?.[4] === "ON") {
            setcaixaDagua01({ alto: true, altoFluxostato: false, normal: false, baixo: false });
        } else if (state[8]?.dados?.[6] === "ON") {
            setcaixaDagua01({ alto: false, altoFluxostato: true, normal: false, baixo: false });
        } else {
            setcaixaDagua01({ alto: false, altoFluxostato: false, normal: true, baixo: false });
        }
    };
    
    const updatecaixaDagua02 = (state) => {
        if (state[9]?.dados?.[1] === "ON") {
            setcaixaDagua02({ alto: false, altoFluxostato: false, normal: false, baixo: true });
        } else if (state[8]?.dados?.[3] === "ON") {
            setcaixaDagua02({ alto: true, altoFluxostato: false, normal: false, baixo: false });
        } else if (state[8]?.dados?.[5] === "ON" || state[9]?.dados?.[3] === "ON") {
            setcaixaDagua02({ alto: false, altoFluxostato: true, normal: false, baixo: false });
        } else {
            setcaixaDagua02({ alto: false, altoFluxostato: false, normal: true, baixo: false });
        }
    };
    

    useEffect(() => {
        console.log("Caixadagua: ", luzesStatus);
        if (luzesStatus.length > 2) {
            updatecaixaDagua01(luzesStatus);
            updatecaixaDagua02(luzesStatus);
        }
    }, [luzesStatus]);
    
    return (
        <>
        <h1 className="tituloCaixa">Nível Caixa D'água</h1>
        <div className="CampoCaixaDagua">

            <div className="caixaDagua01">
                <img src={caixa} alt="CaixaDagua" className="imageCaixa" style={{top: "2%", left: "13.3%"}}/>
                <p className="textoCaixa" style={{top: "24.5%", left: "15.5%",width: "12.5%", height: "21.5%",backgroundColor: caixaDagua01.alto ? "red" : "transparent", clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 6% 100%)"}}>Extravazão</p>
                <p className="textoCaixa" style={{top: "24.5%", left: "28%",  width: "12%", height: "21.5%",backgroundColor: caixaDagua01.altoFluxostato ? "red" : "transparent", clipPath: "polygon(0% 0%, 100% 0%, 92% 100%, 0% 100%)", borderLeft: "2px solid #ccc"}}>Extravazão Fluxostato</p>
                <p className="textoCaixa" style={{ top: "43%", left: "16.15%", width: "23.1%", height: "24%",backgroundColor: caixaDagua01.normal ? "green" : "transparent", clipPath: "polygon(0% 0%, 100% 0%, 95.8% 100%, 4.7% 100%)"}}>Normal</p>
                <p className="textoCaixa" style={{top: "63%", left: "17.2%",  width: "21.1%", height: "24%",backgroundColor: caixaDagua01.baixo ? "red" : "transparent", clipPath: "polygon(0% 0%, 100% 0%, 96.3% 100%, 4.7% 100%)"}}>Baixissímo</p>
                <h2 className="nomeCaixas" style={{top: "90%", left: "15%"}}>Caixa D'água Inferior</h2>
            </div>
            <div className="caixaDagua02">
                <img src={caixa} alt="CaixaDagua" className="imageCaixa"style={{top: "2%", left: "56.3%"}}/>
                <p className="textoCaixa" style={{top: "24.5%", left: "58.5%",  width: "12.5%", height: "21.5%",backgroundColor: caixaDagua02.alto ? "red" : "transparent", clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 6% 100%)"}}>Extravazão</p>
                <p className="textoCaixa" style={{top: "24.5%", left: "71%",  width: "12%", height: "21.5%",backgroundColor: caixaDagua02.altoFluxostato ? "red" : "transparent", clipPath: "polygon(0% 0%, 100% 0%, 92% 100%, 0% 100%)", borderLeft: "2px solid #ccc"}}>Extravazão Fluxostato</p>
                <p className="textoCaixa" style={{ top: "43%", left: "59.15%", width: "23.1%", height: "24%",backgroundColor: caixaDagua02.normal ? "green" : "transparent", clipPath: "polygon(0% 0%, 100% 0%, 95.8% 100%, 4.7% 100%)"}}>Normal</p>
                <p className="textoCaixa" style={{top: "63%", left: "60.2%",  width: "21.1%", height: "24%",backgroundColor: caixaDagua02.baixo ? "red" : "transparent", clipPath: "polygon(0% 0%, 100% 0%, 96.3% 100%, 4.7% 100%)"}}>Baixissímo</p>
                <h2 className="nomeCaixas" style={{top: "90%", left: "58.5%"}}>Caixa D'água Superior</h2>
            </div>
        </div>
        </>
    );
};

export default LegendaCaixadagua;